import React from 'react';
import styled from 'styled-components';

const StyledBox = styled.div`
  height: ${props => props.$heights[0]}px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 14px;
  font-weight: 400;
  background-color: #f4f5f7;
  z-index: 999;
  box-sizing: border-box;

  @media (max-width: 1024px) {
    display: none;
  }
`;

const StyledTitle = styled.div`
  color: #2a64c5;
`;

const StyledDetail = styled.div`
  color: #000000;
  padding-left: 5px;
`;

const Description = ({ heights }) => {
  return (
    <div className="Description">
      <StyledBox $heights={heights}>
        <StyledTitle>
          서울대학교 치과대학 2005 동기 홈페이지 입니다.
        </StyledTitle>
        <StyledDetail>
          사적으로 운영되는 홈페이지입니다. 해당되는 분만 회원가입 후 이용해주세요.
        </StyledDetail>
      </StyledBox>
    </div>
  );
};

export default Description;